import { useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { IFRAME_EMPTY_TITLE } from 'constants/appConstants';
import useMartyContext from 'hooks/useMartyContext';

export const GamIframeSlot = ({ slotName, id, pixelServerHost }) => {
  const { marketplace: { ads: { sourceId } = {} } } = useMartyContext();
  const adIframe = useRef();
  const dimensions = [[728, 90]];

  if (!sourceId) {
    return null;
  }

  const [ width, height ] = dimensions[0];

  const postData = () => {
    const adData = {
      slotName,
      dimensions,
      adsenseId: sourceId,
      id
    };

    adIframe.current.contentWindow.postMessage({ martyAds: { ...adData } }, `https://${pixelServerHost}`);
  };

  return (
    <iframe
      style={{ width: `${width}px`, height: `${height}px`, border: 0 }}
      src={`https://${pixelServerHost}/ads/gam-ads.html`}
      onLoad={postData}
      title={IFRAME_EMPTY_TITLE}
      ref={adIframe} />
  );
};

GamIframeSlot.propTypes = {
  id: PropTypes.string.isRequired,
  slotName: PropTypes.string.isRequired
};

export const mapStateToProps = state => {
  const {
    environmentConfig: {
      pixelServerHost
    }
  } = state;

  return {
    pixelServerHost
  };
};

export default connect(mapStateToProps)(GamIframeSlot);
